import { UtmTracking } from "Types/api/Tracking";
import { getParam } from "src/utils/tracking/helper";
import { getUtmTrackingData, setUtmTrackingData } from "src/utils/localStorage";

export function getUtmTrackingObject(env: string, slug: string): UtmTracking {
    const params = new URLSearchParams(window.location.search);

    // set params to local store so all subsequent pages send tracking data
    if (params.has("utm_source") || params.has("utm_medium") || params.has("utm_campaign")) {
        const utmTracking = {
            source: getParam(params, "utm_source"),
            medium: getParam(params, "utm_medium"),
            campaign: getParam(params, "utm_campaign"),
        };
        setUtmTrackingData({ slug: slug, env: env }, utmTracking);
        return utmTracking;
    }

    return getUtmTrackingData({ env, slug }) ?? {};
}
